import {createSlice, PayloadAction} from '@reduxjs/toolkit';

import * as selectors from 'App/features/autoResults/autoResultsSelectors';

type TAutoResultsSlice = {
  selectedAutoResults: Record<string, number>;
};

const initialState: TAutoResultsSlice = {
  selectedAutoResults: {},
};

const autoResultsSlice = createSlice({
  name: 'autoResults',
  initialState,
  reducers: {
    selectAutoResult(
      state,
      {payload}: PayloadAction<{tenement: string; autoResult: number}>,
    ) {
      state.selectedAutoResults[payload.tenement] = payload.autoResult;
    },
    unselectAutoResult(state, {payload}: PayloadAction<string>) {
      delete state.selectedAutoResults[payload];
    },
    unselectAllAutoResults(state) {
      state.selectedAutoResults = {};
    },
  },
});

export default {
  ...autoResultsSlice,
  selectors,
};
